import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const TraineeshipSupportTable = ({ data, accidentInsurance, size }) => {
    const { t } = useTranslation('translation', { keyPrefix: "traineeships.singleView.recognitionAndSupport.tableC"});

    if (!data) {
        return (
            <Container>
                <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                    <Col>
                        <Row style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <Col className='text-center'>{t('noFinancialSupportAvailable')}</Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        );
    }

    return (
        <Container>
            <Row style={{ paddingLeft: 10, paddingBottom: 15 }}>
                <Col>
                    {/* Financial Support Section */}
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                          {t('receivingOrgWillProvide')}
                        </Col>
                        <Col>{data?.field_tr_pre_tbl_c_fin_sup ? t('yes') : t('no')}</Col>
                    </Row>
                    {data?.field_tr_pre_tbl_c_fin_sup && (
                        <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                            <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                              {t('financialSupportValue')}
                            </Col>
                            <Col>{data?.field_tr_pre_tbl_c_fin_sup_value || ''}</Col>
                        </Row>
                    )}

                    {/* Contribution in Kind Section */}
                    <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={12}></Col>
                    </Row>
                    <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                          {t('receivingOrgWillProvideContribution')}
                        </Col>
                        <Col>{data?.field_tr_pre_tbl_c_contribution ? t('yes') : t('no')}</Col>
                    </Row>
                    {data?.field_tr_pre_tbl_c_contribution && (
                        <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                            <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                {t('contributionValue')}
                            </Col>
                            <Col>{data?.field_tr_pre_tbl_c_contr_value || ''}</Col>
                        </Row>
                    )}

                    {/* Accident Insurance Section */}
                    {accidentInsurance && (
                        <>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}>
                                    <strong>{t('accudentInsuranceCoverage')}</strong>
                                </Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('accidentInsurance')}
                                </Col>
                                <Col>{accidentInsurance?.field_acc_ins ? t('yes') : t('no')}</Col>
                            </Row>
                            {accidentInsurance?.field_acc_ins && (
                                <>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            {t('coverageOnTheWay')}
                                        </Col>
                                        <Col>{accidentInsurance?.field_acc_cov_way ? t('yes') : t('no')}</Col>
                                    </Row>
                                    <Row style={{ paddingTop: 10, paddingBottom: 2, paddingLeft: 20 }}>
                                        <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                            {t('coverageDuringTravel')}
                                        </Col>
                                        <Col>{accidentInsurance?.field_acc_cov_travel ? t('yes') : t('no')}</Col>
                                    </Row>
                                </>
                            )}
                            <Row style={{ paddingTop: 15, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={12}></Col>
                            </Row>
                            <Row style={{ paddingTop: 10, paddingBottom: 2 }}>
                                <Col className='border-hidden label-style' xs={6} sm={5} md={5}>
                                    {t('liabilityInsurance')}
                                </Col>
                                <Col>{accidentInsurance?.field_acc_ins_liability ? t('yes') : t('no')}</Col>
                            </Row>
                        </>
                    )}
                </Col>
            </Row>
        </Container>
    );
}

export default TraineeshipSupportTable;